module.exports = __webpack_public_path__ + "assets/img/medical.e70b809a.png";